<section class="mojo-admin-page panel data-table full-page-widget full-page-scrollable">
  <div class="panel-body">

    <div class="data-table widget-content">

      <div class="row panel-heading">
        <div class="table-search">
          <input #gb class="form-control" (input)="dt.filterGlobal($event.target.value, 'contains')"
                 placeholder="Search..." pInputText type="text">
        </div>
        <div class="user-profile-assignment-controls">
          <button type="button" pButton [disabled]="selectedUserProfiles.length == 0" (click)="openDialog()"
                  label="Change Selected"></button>
          <button type="button" pButton (click)="toggleCodesDescriptions()"
                  [label]="displayCodes ? 'Show Descriptions' : 'Show Codes'"></button>
        </div>
      </div>

      <div #container class="data-table table-container">
        <p-table #dt [value]="userProfiles"
                 [rows]="8"
                 [columns]="getPrimeColumns()"
                 selectionMode="multiple"
                 [(selection)]="selectedUserProfiles"
                 [scrollable]="true"
                 scrollHeight="570px"
                 responsiveLayout="scroll"
                 (onFilter)="onFilter($event)">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [style.width]="getColSize(col)">
                {{ col.header }}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
              <th style="width: 50px"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-userProfile let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData">
              <td *ngFor="let col of columns" class="ui-resizable-column" [style.width]="getColSize(col)">
                {{ rowData[col.field] }}
              </td>
              <td style="width: 50px" class="table-selected-column"><i class="fa fa-check" aria-hidden="true"
                                                                       *ngIf="isRowSelected(rowData)"></i></td>
            </tr>
          </ng-template>
        </p-table>
        <mojo-table-paginator [table]="dt"></mojo-table-paginator>
      </div>
    </div>
  </div>
</section>


<p-dialog header="Select Profile" [(visible)]="displayDialog" showEffect="fade" [modal]="true"
          [closable]="false" appendTo="body" [resizable]="true" [style]="{minWidth: '260px', minHeight:'230px'}">

  <div class="profile-selection-dialog-container">
    <div class="row">
      <div class="col-sm-3 row-header">User(s)</div>
      <div class="col-sm-9">{{ getSelectedUserIdsAsCsv() }}</div>
    </div>
    <div class="row">
      <div class="col-sm-3 row-header">Profile</div>
      <div class="col-sm-9">
        <p-dropdown hideDropdownOnScroll appendTo="body" [options]="profiles" dataKey="id" [(ngModel)]="selectedProfile"
                    placeholder="Select a Profile" optionLabel="name" [showClear]="true"></p-dropdown>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="btn-group admin-form" role="group" aria-label="...">
      <button type="button" pButton icon="fa-fw fa fa-check" [disabled]="!selectedProfile" (click)="changeSelected()"
              label="Ok"></button>
      <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancel()" label="Cancel"></button>
    </div>
  </p-footer>
</p-dialog>
